import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'
const Dotnet = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);
  return (
    <div>
<div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Blog Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">Why ASP.NET Full Stack Developer</h1>
          <p>Explore our comprehensive ASP.NET full stack development course curriculum, designed to provide hands-on experiences in building dynamic applications. Our experienced instructors bring industry expertise to guide you through the journey, accommodating various skill levels. Upon successful completion of the course, you'll be well-prepared for placement opportunities and will earn a valuable certification from DevPro Academy.</p>
          <p><b>Session 1: Introduction to Web Development</b></p>
          <p>Understanding Web Architecture, Introduction to HTML and CSS</p>
          <b>Session 2: Introduction to ASP.NET</b>
          <p>ASP.NET Basics, WebForms vs. MVC, Server Controls</p>
          <b>Session 3: C# Programming</b>
          <p>C# Basics, Data Types, Operators, Control Structures</p>
          <b>Session 4: ASP.NET WebForms</b>
          <p>Creating WebForms, Working with Events, ViewState</p>
          <b>Session 5: ASP.NET MVC</b>
          <p>MVC Architecture, Models, Views, Controllers</p>
          <b>Session 6: Entity Framework</b>
          <p>ORM Concepts, Database First Approach, LINQ</p>
          <b>Session 7: SQL Server</b>
          <p>Database Design, SQL Queries, Stored Procedures</p>
          <b>Session 8: ASP.NET and Database Integration</b>
          <p>Connecting ASP.NET with SQL Server, Data Binding</p>
          <b>Session 9: Web API Development</b>
          <p>Building RESTful APIs, Consuming APIs</p>
          <b>Session 10: Frontend Development with JavaScript</b>
          <p>Introduction to JavaScript, DOM Manipulation, AJAX</p>
          <b>Session 11: ASP.NET Core</b>
          <p>Introduction to ASP.NET Core, Building Cross-Platform Apps</p>
          <b>Session 12: Authentication and Authorization</b>
          <p>Implementing User Authentication, Role-Based Authorization</p>
          <b>Session 13: Version Control with Git</b>
          <p>Using Git for Source Control and Collaboration</p>
          <b>Session 14: Deployment Strategies</b>
          <p>Deploying ASP.NET Applications, Hosting Options</p>
          <b>Session 15: Project Development</b>
          <p>Hands-On Project to Apply Skills in Real-world Scenarios</p>
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}
        <div className="mb-5">
          <div className="section-title section-title-sm position-relative pb-3 mb-4">
            <h3 className="mb-0">Comments</h3>
          </div>
        </div>
        {/* Comment List End */}
        {/* Comment Form Start */}
        <Comment/>
        {/* Comment Form End */}
      </div>
      <div className="col-lg-4">
        {/* Search Form Start */}
        <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
 
      {/* Sidebar Start */}
    </div></div></div>

   

  
 
 

  )
}

export default Dotnet